module.exports = __webpack_public_path__ + "img/nft.2c003679.png";